import type { ReactNode } from "react";
import { forwardRef } from "react";
import clsx from "clsx";

/**
 * Äußerer Rahmen für alle React-Datentabellen (Border, Radius, Schatten,
 * horizontales Scrollen). Inhalt: `<table className="eh-data-table">`.
 */
export const EhDataTableShell = forwardRef<
  HTMLDivElement,
  {
    children: ReactNode;
    className?: string;
  }
>(function EhDataTableShell({ children, className }, ref) {
  return (
    <div
      ref={ref}
      className={clsx(
        "overflow-x-auto rounded-ios border border-separator bg-card shadow-ios",
        className,
      )}
    >
      {children}
    </div>
  );
});
